import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import {
    FOOTER_HEIGHT_DESKTOP,
    HT_DESKTOP_HEADER_HEIGHT,
} from '@/lib/constants/hyperTrackerConstants';

export const Wrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
    scrollbarWidth: 'none',
    overflowY: 'hidden',
    overflowX: 'hidden',
    // `clip` doesn't create a scroll container, so `position: sticky` descendants work.
    '@supports (overflow: clip)': {
        overflowX: 'clip',
        overflowY: 'clip',
    },
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    backgroundColor: theme.palette.backgrounds.bg0,
}));

export const ProspectiveGrid = styled(Box)(() => ({
    width: '100%',
    height: '300px',
    bottom: '-70px',
    position: 'fixed',
    background:
        'linear-gradient(rgba(255, 255, 255, 0.10) 2px, transparent 2px), linear-gradient(90deg, rgba(255, 255, 255, 0.10) 2px, transparent 2px)',
    backgroundSize: '60px 20px',
    transform: 'perspective(800px) rotateX(65deg)',
    transformOrigin: 'center top',
    overflow: 'hidden',
    opacity: 0.7,
    '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'linear-gradient( black, transparent)',
        opacity: 1,
        pointerEvents: 'none',
    },
}));

export const TopGreenLight = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '80px',
    backgroundColor: theme.palette.backgrounds.greenLightningBg,
    borderRadius: '100%',
    transform: 'translateY(-40%)',
    filter: 'blur(40px)',
    pointerEvents: 'none',
    zIndex: 0,
    display: 'flex',

    [theme.breakpoints.down('md')]: {
        borderRadius: '30%',
        transform: 'translateY(-30%)',
    },

    [theme.breakpoints.down('sm')]: {
        borderRadius: 0,
        transform: 'translateY(-20%)',
    },
}));

export const BottomGreenLight = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '80px',
    backgroundColor: theme.palette.backgrounds.greenLightningBg,
    borderRadius: '100%',
    transform: 'translateY(70%)',
    filter: 'blur(40px)',
    pointerEvents: 'none',
    zIndex: 0,

    [theme.breakpoints.down('md')]: {
        borderRadius: '30%',
        transform: 'translateY(70%)',
    },

    [theme.breakpoints.down('sm')]: {
        borderRadius: 0,
        transform: 'translateY(80%)',
    },
}));

export const OutletWrapper = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    width: '100%',
    zIndex: 1,
    transition: `0.3s ease`,
    minHeight: `calc(100vh - ${HT_DESKTOP_HEADER_HEIGHT}px - ${FOOTER_HEIGHT_DESKTOP}px )`,
    height: '100%',
    paddingBottom: '40px',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
        marginTop: `${HT_DESKTOP_HEADER_HEIGHT}px`,
    },
}));

export const BoxGreenLight = styled(Box)({
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    top: 0,
    left: 0,
});
